import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Load Plausible analytics in production only
if (import.meta.env.PROD) {
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = 'https://plausible.io/js/pa-vC16xLfJylbr5YxtMXfgi.js';
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.plausible=window.plausible||function(){(plausible.q=plausible.q||[]).push(arguments)},plausible.init=plausible.init||function(i){plausible.o=i||{}};
    plausible.init()
  `;
  document.head.appendChild(script2);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
